/* eslint-disable import/prefer-default-export */
import { slugify } from '../constants/taxonomy';

function path(sublink: string) {
  return `${sublink}`;
}

export const paths = {
  recipe: {
    root: path('/recipes'),
    detail: (idOrSlug: string) => path(`/recipe/${idOrSlug}`),

    // Faceted routes
    category: (category: string) => path(`/recipes/category/${slugify(category)}`),
    cuisine: (cuisine: string) => path(`/recipes/cuisine/${slugify(cuisine)}`),
    diet: (diet: string) => path(`/recipes/diet/${slugify(diet)}`),
    method: (method: string) => path(`/recipes/method/${slugify(method)}`),
    collection: (attribute: string) => path(`/recipes/collection/${slugify(attribute)}`),

    // Legacy routes (for backwards compatibility)
    tagName: (tagName: string) => path(`/recipeTag/${tagName}`),

    // Admin
    admin: path('/admin'),
  },
};
